"use client";
import { useState } from "react";
import { usePathname } from "next/navigation";

/** The site menu (Buds, 3 Oct 2026): Home · Features · Life Areas · Pricing · Contact · Get Started →. Below md the five pages fold into a hamburger. */
const ITEMS: [string, string][] = [["Home", "/"], ["Features", "/features"], ["Life Areas", "/areas"], ["Pricing", "/pricing"], ["Contact", "/contact"]];
export function SiteNav({ app }: { app: string }) {
  // Behind the host router the pathname carries the surface folder (/www/contact); strip it so the menu sees /contact.
  const path = (usePathname() ?? "/").replace(/^\/(www|app|admin)(?=\/|$)/, "") || "/";
  const [open, setOpen] = useState(false);
  const active = (href: string) => href === "/" ? path === "/" : path.startsWith(href);
  return (
    <>
      <nav className="flex items-center gap-1 sm:gap-2 text-[15px]">
        {ITEMS.map(([label, href]) => <a key={href} href={href} className={`hidden md:inline rounded-full px-3.5 py-2 font-medium transition-colors ${active(href) ? "bg-[#eef0ff] text-indigo" : "text-ink/80 hover:text-indigo"}`}>{label}</a>)}
        <a href={`${app}/login`} className="hidden sm:inline font-medium text-ink/80 hover:text-indigo px-2 sm:ml-2">Log in</a>
        <a href={`${app}/signup`} className="btn-primary h-10 px-4 text-sm shadow-[0_8px_20px_rgba(99,102,241,.25)]">Get Started →</a>
        <button type="button" onClick={() => setOpen((o) => !o)} aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} className="md:hidden ml-1 grid h-10 w-10 place-items-center rounded-xl border border-line bg-white text-ink">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">{open ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}</svg>
        </button>
      </nav>
      {open ? (
        <div className="md:hidden absolute inset-x-0 top-16 border-b border-line bg-white shadow-[0_20px_50px_rgba(17,24,39,.12)]">
          <div className="mx-auto max-w-6xl px-4 py-3 flex flex-col">
            {ITEMS.map(([label, href]) => <a key={href} href={href} className={`rounded-xl px-3 py-3 text-base font-medium ${active(href) ? "bg-[#eef0ff] text-indigo" : "text-ink"}`}>{label}</a>)}
            <a href={`${app}/login`} className="rounded-xl px-3 py-3 text-base font-medium text-ink sm:hidden">Log in</a>
          </div>
        </div>) : null}
    </>
  );
}
